<template>
  <div class="wrapper">

    <div class="header_wrapper">
      <v-toolbar
        class="fixed_toolbar"
        color="primary"
        dark
      >
        <v-btn
          @click="routerBack"
          style="position: absolute"
          icon
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
        <v-spacer />
        <v-toolbar-title>児童票</v-toolbar-title>
        <v-spacer />
      </v-toolbar>
    </div>

    <div class="content_wrapper">
      <div
        v-for="c in children"
        :key="c.childId"
      >
        <div class="pa-1 name-wrapper d-flex align-center">
          <div class="icon mr-2">
            <img
              :src="c.imageUrl? c.imageUrl : 'https://via.placeholder.com/240x180?text=Sample+Image+1'"
            >
          </div>
          <h5>{{ c.lastName }}{{ c.firstName }}</h5>
        </div>

        <v-list density="compact">
          <!-- 1. v-list-item-group は削除し、key は template タグに移動 -->
          <template v-for="(item, index) in items" :key="item.title">
            
            <v-list-item
              @click="to( item.path, item.name, c.childId, c.lastName + c.firstName )"
            >
              <!-- 2. v-list-item-content 廃止 → title を直下に配置 -->
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item>

            <v-divider />
          </template>
        </v-list>
      </div>
    </div>

  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';

import { familyModule } from '@/store/entityModules/family';

export default defineComponent({

  computed: {
    children() {
      if (familyModule.family) {
        return familyModule.family.children;
      }
      return [];
    },
  },

  data: () => ({
    items: [
      {
        title: '基本情報',
        badgeNum: 0,
        to: 'ChildrenBasic',
        path: '/children/basic',
      },
      {
        title: '生活状況',
        badgeNum: 0,
        to: 'ChildrenCondition',
        path: '/children/condition',
      },
      {
        title: '健康発育状況',
        badgeNum: 0,
        to: 'ChildrenGrowth',
        path: '/children/growth',
      },
    ],
  }),

  methods: {
    routerBack() {
      this.$router.replace('/setting');
    },
    to(path: string, name: string, childId: string, childName: string) {
      this.$router.push({ name, query: {
        childId,
        childName,
      } });
    },
  },

});
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%; /* Fallback */
  height: calc(var(--vh, 1vh) * 100);
  overflow-y: scroll;
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: env(safe-area-inset-top);
  }

  .header_wrapper {
    height: 56px;
    width: 100%;
    position: fixed;
    z-index: 1;

    .outline {
      border: 1px solid rgb(var(--v-theme-primary));
    }
    @supports (bottom: env(safe-area-inset-bottom)) {
      padding-top: env(safe-area-inset-top);
    }
  }

  .content_wrapper {
    min-height: calc(100% - 56px);
    margin: 56px 0 0px;
    overflow-y: hidden;

    .name-wrapper {
      background-color: #F5F6F6;
      .icon {
        height: 40px;
        width: 40px;

        img {
          height: 100%;
          width: 100%;
          border-radius: 100%;
          object-fit: cover;
        }
      }
    }
  }
}
</style>
